import React, { useEffect, useState } from 'react';
import {
  Container,
  Button,
  Card,
  Form,
  Row,
  Col,
  Spinner,
  Modal,
} from 'react-bootstrap';
import UsersRequestService from '../../services/users-request';
import ResalesRequestService from '../../services/resales-request';
import { MasterAgentProfiles, ProfileType, AdminProfiles } from '../../helpers/Enum/index';
import FileUpload from 'components/FileUpload';
import { GroupAddOutlined, ArrowBackOutlined } from '@material-ui/icons';
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import Alert from '../../helpers/alert';
import { useHistory } from 'react-router';
import MultiSelect from '@kenshooui/react-multi-select';
import Loading from 'components/Loading';
import { useUser } from 'models';
import ProfilesRequestService from 'services/profiles-request';

import 'react-dual-listbox/lib/react-dual-listbox.css';
import 'react-datepicker/dist/react-datepicker.css';
import "@kenshooui/react-multi-select/dist/style.css";

export default function () {
  const { profile: uProfile } = useUser()

  const { fiscal_year } = useUser();
  const [user, setUser] = useState({});
  const [profile, setProfile] = useState({});

  const [submited, setSubmited] = useState(false);

  const [isLoad, setLoad] = useState(false);
  const [getUserIsLoading, setGetUserIsLoading] = useState(false);

  const [languages, setLanguages] = useState([]);
  const [profileOptions, setProfileOptions] = useState([]);
  const [listCompany, setListCompany] = useState([]);

  const [listCompanySelected, setListCompanySelect] = useState([]);
  const [auxListCompanySelected, setAuxListCompanySelected] = useState([]);
  const [imageProfile, setImageProfile] = useState(null);
  const [logoPreview, setLogoPreview] = useState(null);

  const [areaSelected] = useState(1);
  const [companyFiscalYear] = useState(fiscal_year.id);
  const [premium, setPremium] = useState("");
  const [masterAgent, setMasterAgent] = useState(MasterAgentProfiles.includes(uProfile.id) ? 1 : "");
  const [verifiedLimitUsers, setVerifiedLimitUsers] = useState([]);

  const [showModalToActivate, setShowModalToActivate] = useState(false);
  const [idToRestore, setIdToRestore] = useState(null)
  const [restoring, setRestoring] = useState(false)

  const history = useHistory();
  const { id } = useParams();

  useEffect(() => {
    getAreasProfiles();
    getAreaResales(1);
    if (id) {
      getUser();
      getUserProfile();
      getUserResales();
    }
  }, []);

  useEffect(() => {
    if (submited) {
      let message = id
        ? "Usuário atualizado com sucesso"
        : "Usuário Criado com sucesso";
      setLoad(false);

      Alert.success(message).then((result) => {
        if (result.dismiss === Swal.DismissReason.timer) {
          history.push('/users')
        }
      });
    }
  }, [submited]);

  useEffect(() => {
    //if (listCompany.length == 0)
      getAreaResales(1);
  }, [companyFiscalYear, premium, masterAgent])

  const getLanguages = () => {
    let request = UsersRequestService.getLanguages();
    request.then((data) => {
      setLanguages(data.data.data);
    });
  };

  const getAreasProfiles = () => {
    ProfilesRequestService.get()
      .then((response) => {
        const { data } = response.data
        setProfileOptions(data);
      });
  };

  const getUser = () => {
    setGetUserIsLoading(true);
    let request = UsersRequestService.getUser(id);
    request.then(({ data }) => {
      setLogoPreview(
        data.url_image_profile
          ? data.url_image_profile
          : null
      );
      setUser({
        ...user,
        ...data,
      });
    }).finally(() => setGetUserIsLoading(false));
  };

  const getUserProfile = () => {
    let request = UsersRequestService.getUserProfiles(id);
    request.then((data) => {
      let profile = {};
      data.data.data.forEach((p) => {
        profile[1] = p.id;
      });
      setProfile(profile);
    });
  };

  const getAreaResales = (area_id) => {
    var params = {
      fiscal_year_id: companyFiscalYear,
      premium: premium,
      masteragent: masterAgent
    }

    if (MasterAgentProfiles.includes(uProfile.id)) {
      delete params.premium
    }

    let request = ResalesRequestService.getAreaResales(area_id, { params });
    request.then((data) => {
      const { data: companies } = data
      setListCompany(
        companies.map((c) => {
          return {
            id: c.company_id,
            label: (c.alias ? c.alias : c.name) + ' - ' + formatDocumentCompany(c.document),
          };
        })
      );
    });
  };

  const getUserResales = () => {
    let request = UsersRequestService.getUserResales(id);
    request.then(({ data }) => {
      let lcs = [];
      let ids = verifiedLimitUsers;
      data.data.forEach((c) => {
        ids.push(c.id);
        lcs.push({ id: c.id, label: `${c.name} - ${formatDocumentCompany(c.document)} ` });
      });
      setVerifiedLimitUsers(ids);
      setListCompanySelect(lcs);
    });
  };

  const formatDocumentCompany = document => (
    document.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
  );

  const verifyAlreadyExists = value => {
    if (value.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)) {
      UsersRequestService.verifyAlreadyExists({
        params: {
          email: value
        }
      })
        .then(({ data: data }) => {
          if (data.has) {
            setIdToRestore(data.id)
            setShowModalToActivate(true)
          }
        })
    }
  }

  const restoreUser = () => {
    if (idToRestore) {
      setRestoring(true)
      UsersRequestService.restore(idToRestore)
        .then(() => history.goBack())
        .finally(() => setRestoring(false))
    }
  }

  const handleCloseModal = () => setShowModalToActivate(false)

  const inputs = [
    { width: 4, title: 'Nome:', key: 'name', disable: false },
    { width: 4, title: 'Sobrenome:', key: 'lastname', disable: false },
    { width: 4, title: 'E-mail:', key: 'email', disable: id ? true : false, cb: verifyAlreadyExists },
    { width: 4, title: 'Telefone:', key: 'phone', disable: false },
    { width: 4, title: 'Alias:', key: 'alias', disable: false },
  ];

  const createInputs = () => {
    const getOptions = (options) => {
      return (
        <>
          <option value="" disabled={true}>
            Selecione
          </option>
          {options.map((option, k) => {
            return (
              <option key={k} value={option.id}>
                {option.name}
              </option>
            );
          })}
        </>
      );
    };

    return (
      <>
        {inputs.map((input, k) => {
          return (
            <Col xl={input.width} key={k}>
              <Form.Group>
                <Form.Label>{input.title}</Form.Label>
                <Form.Control
                  as={input.as ? input.as : 'input'}
                  value={getValue(input.key)}
                  onChange={(e) => {
                    if (input.cb && !id) {
                      input.cb(e.target.value)
                    }
                    setValue(input.key, e.target.value)
                  }}
                  disabled={input.disable}
                >
                  { }
                  {input.options ? getOptions(input.options) : null}
                </Form.Control>
              </Form.Group>
            </Col>
          );
        })}
      </>
    );
  };

  const submit = () => {
    //setLoad(true);
    let model = [
      { key: 'id' },
      { key: 'name', required: true },
      { key: 'lastname', required: true },
      { key: 'email', required: true },
      { key: 'phone' },
      { key: 'alias' },
      { key: 'language_id', required: true },
      { key: 'profile_id', required: true }
    ];

    const formData = new FormData();

    model.forEach((item) => {
      if (item.required) {
        if (
          user[item.key] &&
          user[item.key] !== '' &&
          user[item.key] !== null &&
          user[item.key] !== 0
        )
          formData.append(item.key, user[item.key]);
      } else formData.append(item.key, user[item.key] ? user[item.key] : '');
    });

    if (imageProfile) formData.append('file', imageProfile);

    let companies = [];
    // Object.values(listCompanySelected).forEach((a) => {
    //   a.forEach((b) => {
    //     companies.push(b.id);
    //   })
    // })
    if (listCompanySelected.length > 0 && isResale()) {
      listCompanySelected.forEach((selected, i) => {
        formData.append(`companies[${i}]`, selected.id);
      })
    }

    formData.append('profile_id', user.profile_id);

    if (id) {
      formData.append("_method", "put");
      UsersRequestService.update(id, formData)
        .finally(() => {
          setLoad(false);
          setSubmited(true);
        });
    } else {
      UsersRequestService.save(formData)
        .finally(() => {
          setLoad(false);
          setSubmited(true);
        });
    }
  };

  const getValue = (name) => {
    return user[name] ? user[name] : '';
  };

  const setValue = (name, value) => {
    let user_aux = { ...user };
    user_aux[name] = value;
    setUser({ ...user_aux });
  };

  const isResale = () => {
    if (profile && profileOptions) {
      if (profileOptions) {
        let profile_aux = profileOptions.filter(
          (p) => p.id === parseInt(user.profile_id)
        )[0];
        if (profile_aux)
          if ([ProfileType.Resale, ProfileType.Attendance].includes(profile_aux.profile_type_id))
            return true;
      }
    }
    return false;
  };

  return (
    <>
      <Container>
        <Row className="mt-4">
          <Button variant="link" onClick={() => {
            history.goBack()
          }}>
            <ArrowBackOutlined /> Voltar
          </Button>
        </Row>
        <Row className="col-12 mt-4 row">
          <GroupAddOutlined className="icon-title" />
          <h5 className="title-dashboard">
            Usuário - {getValue('name') ? getValue('name') : 'Criar'}
          </h5>
        </Row>
        <Row className="col-12">
          <Card.Body className="card-dashboard shadow bg-white rounded m-2 p-5 col-12">
            {getUserIsLoading ? (<Loading page />) : (<>
              <Form>
                <Row>
                  {createInputs()}
                  <Col xl={4}>
                    <Form.Group>
                      <Form.Label>Perfil:</Form.Label>
                      <Form.Control
                        as="select"
                        value={user.profile_id}
                        onChange={(e) => {
                          let profile_aux = profileOptions.filter(
                            (p) => p.id === parseInt(e.target.value)
                          )[0];

                          if ([ProfileType.Resale, ProfileType.Attendance].includes(profile_aux.profile_type_id)) {
                            //getAreaResales(areasProfiles[0].id);
                            setListCompanySelect(auxListCompanySelected);
                          } else {
                            setListCompany([]);
                            setAuxListCompanySelected(listCompanySelected);
                            setListCompanySelect([])
                            // let lcs = { ...listCompanySelected };
                            // lcs[1] = [];
                            // setListCompanySelect(lcs);
                          }

                          let aux = { ...user };
                          //aux[1] = e.target.value;
                          aux.profile_id = e.target.value;
                          setUser(aux)
                          //setProfile({ ...aux });
                          setVerifiedLimitUsers([]);
                        }}
                      >
                        <option value="">Selecione</option>
                        {profileOptions.map((profile, k) => (
                          <option
                            value={profile.id}
                            key={k}
                            type_profile={profile.profile_type_id}
                          >
                            {profile.name}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
              {isResale() ? (
                <Card.Body>
                  <h6>
                    {'Selecione as revendas atendidas pelo usuário:'}
                  </h6>
                  <Row>
                    {/* <Col sm={4}>
                    <Form.Group>
                      <Form.Label>Ano Fiscal:</Form.Label>
                      <Form.Control
                          as="select"
                          value={companyFiscalYear}
                          onChange={(e) => setCompanyFiscalYear(e.target.value)}
                        >
                          <SelectFiscalYearsDefault />
                      </Form.Control>
                    </Form.Group>
                  </Col> */}
                    {!MasterAgentProfiles.includes(uProfile.id) ? (
                      <Col md="3">
                        <Form.Group>
                          <Form.Label>Elite:</Form.Label>
                          <Form.Control
                            as="select"
                            value={premium}
                            onChange={(e) => setPremium(e.target.value)}
                          >
                            <option value="">Todos</option>
                            <option value={1}>Sim</option>
                            <option value={0}>Não</option>
                          </Form.Control>
                        </Form.Group>
                      </Col>
                    ) : (<></>)}
                    <Col md="3">
                      <Form.Group>
                        <Form.Label>Masteragent:</Form.Label>
                        <Form.Control
                          disabled={MasterAgentProfiles.includes(uProfile.id)}
                          as="select"
                          value={masterAgent}
                          onChange={(e) => setMasterAgent(e.target.value)}
                        >
                          <option value="">Todos</option>
                          <option value={1}>Sim</option>
                          <option value={0}>Não</option>
                        </Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <MultiSelect
                    messages={{
                      searchPlaceholder: "Procurar...",
                      noItemsMessage: "Sem Itens...",
                      noneSelectedMessage: "Nada Selecionado",
                      selectedMessage: "Selecionado(s)",
                      selectAllMessage: "Selecionar Todos",
                      clearAllMessage: "Limpar Tudo",
                      disabledItemsTooltip: "Você só pode selecionar 1 arquivo"
                    }}
                    items={listCompany}
                    maxSelectedItems={user.profile_id == MasterAgentProfiles[2] ? 1 : null}
                    selectedItems={listCompanySelected}
                    onChange={async (selected) => {
                      if (selected.length > 0) {
                        // let lcs = { ...listCompanySelected }
                        // lcs = selected;
                        setListCompanySelect(selected);

                        let profileSelected = profileOptions.filter((profileItem) => {
                          if (profileItem.id == user.profile_id)
                            return profileItem;
                        })[0];

                        let idToVerify = null;
                        for (let s of selected) {
                          if (!verifiedLimitUsers.includes(s.id)) {
                            idToVerify = s.id;
                            break;
                          }
                        }

                        if (idToVerify && selected.length > 0 && parseInt(profileSelected.profile_type_id) === ProfileType.Resale
                          && profileSelected.id != 47 // Gestor Master Agent
                        ) {
                          let response = await ResalesRequestService.verifyLimitUsers(idToVerify);
                          setVerifiedLimitUsers([...verifiedLimitUsers, idToVerify])
                          if (response.data.has_exceeded_limit) {
                            Alert.error(`
                              Limite de 4 usuários para essa revenda foi excedido. 
                              Por favor inative um usuário dessa 
                              revenda antes de adicionar outro`
                            );

                            /*let lcs = { ...listCompanySelected }
                            lcs[areaSelected] = selected.slice(0, -1);*/
                            setListCompanySelect(selected.slice(0, -1));
                            return;
                          }
                        }

                      }
                    }}
                  />
                </Card.Body>
              ) : (
                ''
              )}
              <Row className="mb-3 mt-4">
                <Col xs={12}>
                  <Form.Group>
                    <Form.Label>Selecione a foto do atendente:</Form.Label>
                    <FileUpload
                      file={imageProfile}
                      setFile={setImageProfile}
                      preview={logoPreview}
                      setPreview={setLogoPreview}
                    />
                  </Form.Group>
                </Col>
              </Row>
              {isLoad ? (
                <Spinner animation="border" style={{ color: '#e05c17' }} />
              ) : (
                <Button onClick={() => submit()}>Salvar</Button>
              )}
            </>)}
          </Card.Body>
        </Row>
      </Container>
      <Modal
        centered
        backdrop="static"
        show={showModalToActivate}
        onHide={handleCloseModal}
      >
        <Modal.Header closeButton>
          <Modal.Title>Reativar Usuário</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Esse email está associado a um usuário desativado !<br />
          Deseja reativa-lo ?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Não
          </Button>
          <Button disabled={restoring} variant="success" onClick={restoreUser}>
            Sim {restoring ? <Spinner animation="border" size="sm" /> : (<></>)}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
